import * as request from '@/utils/request'

export default {
  /**
   * @description 提交登录信息，进行登录
   * @author YM
   * @date 2019-02-12
   * @returns
   */
  submitLoginInfo(data) {
    return request.post('/passport/login',data)
  },
  /**
   * 临时令牌登录，返回 data 结构与 /passport/login 一致（含 sid 等）
   * @param {{ token: string }} data
   */
  tokenLogin(data) {
    return request.post('/passport/token_login', data)
  },
  /**
   * @description 提交退出登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitLogout() {
    return request.post('/passport/logout')
  },
  /**
   * @description 获取验证码
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  getCode(data) {
    return request.post('/sms/send', data)
  },
  getLoginCode(data){
    return request.post('/sms/sendSms', data)
  },
  /**
   * @description 发送短信给审核人员
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  sendCodeToAudit(data) {
    return request.post('/task/send_msg_audit', data)
  },

  /**
   * @description 获取审核人员手机号
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  getStaffAudit(data) {
    return request.post('/task/staff_audit', data)
  },

  /**
   * 短信验证码校验
   * @param {*} data
   */
  verifyCode(data) {
    return request.post('/sms/verify', data)
  },
  /**
   * @description 短信验证码登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitCodeLogin(data) {
    return request.post('passport/sms_login',data)
  }


}